import PropTypes from 'prop-types'
import React from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import { SubmissionError } from 'redux-form'
import { LABEL_NAME_MAX_LENGTH } from 'const/limits'
import {
  Button,
  ButtonGroup
} from 'react-bootstrap'
import {
  BoardModalView,
  ViewBody
} from 'components/Sidebar'
import withLeftSidebar from 'components/Sidebar/withLeftSidebar'
import LabelForm from '../LabelForm'

export class AddLabel extends React.Component {
  static propTypes = {
    boardContext: PropTypes.object.isRequired,

    intl: PropTypes.object.isRequired,
    leftSidebar: PropTypes.object.isRequired,

    requestAddLabel: PropTypes.func.isRequired
  }

  cancelForm = () => {
    this.props.leftSidebar.pop()
  }

  handleFormSubmit = ({ name, color }) => {
    const { cancelForm } = this
    const { boardContext, intl, requestAddLabel } = this.props

    return new Promise((masterResolve) => {
      if (!name) {
        throw new SubmissionError({
          name: intl.formatMessage({ id: 'LABEL_EMPTY' })
        })
      } else if (name.length > LABEL_NAME_MAX_LENGTH) {
        throw new SubmissionError({
          name: intl.formatMessage(
            { id: 'LABEL_TOO_LONG' },
            { limit: LABEL_NAME_MAX_LENGTH }
          )
        })
      }

      requestAddLabel({
        boardId: boardContext.id,
        name,
        color,
      }).then(() => {
        masterResolve()

        cancelForm()
      }).catch(error => {
        throw new SubmissionError({
          name: error.message,
          _error: error.message
        })
      })
    })
  }

  render () {
    return (
      <BoardModalView
        title={<FormattedMessage id='LABEL_ADD' />}
      >
        <ViewBody>
          <LabelForm
            form={'addLabel'}
            onSubmit={this.handleFormSubmit}
            initialValues={{
              name: '',
              color: Math.floor(Math.random() * 16)
            }}
            actions={({ submitting }) =>
              <ButtonGroup>
                <Button
                  type='submit'
                  bsStyle='primary'
                  disabled={submitting}
                >
                  <FormattedMessage id='ADD' />
                </Button>
                <Button
                  disabled={submitting}
                  onClick={this.cancelForm}
                >
                  <FormattedMessage id='CANCEL' />
                </Button>
              </ButtonGroup>
            }
          />
        </ViewBody>
      </BoardModalView>
    )
  }
}

export default injectIntl(withLeftSidebar(AddLabel))

